import {User} from "../user";
import {Media} from "./media";

export class Tweet {
  activated:boolean;

  creationDate: number;

  id:number;

  height:number = 0;

  miniatureHeight:number = 0;

  miniatureUrl: string;

  miniatureWidth:number = 0;

  nbComments: number;

  owner:User;

  url: string = "";

  width:number = 0;

  downloadUrl:string;

  caption: string;

  description: string;

  medias: Array<Media>;

  twitterId: number;

  twitterName: string;

  screenName: string;

  avatarUrl: string;

  constructor(tweet?: Tweet, media?: Media) {
    if(tweet!=null) {
      this.id = tweet.id;
      this.activated = tweet.activated;
      this.caption = tweet.caption;
      this.description = tweet.description;
      if(media!=null) {
        this.medias = [media];
      } else {
        this.medias = tweet.medias;
      }
      this.twitterId = tweet.twitterId;
      this.twitterName = tweet.twitterName;
      this.screenName = tweet.screenName;
      this.avatarUrl = tweet.avatarUrl;
    }
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/model/social/tweet.ts